import React, { Component } from 'react';
// import PropTypes from "prop-types";
import { connect } from "react-redux";
// // import { setTitle } from "../actions/AppActions";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {
  PhoneIcon,
  EditIcon
} from '../bundles/IconsBundle';
import MapContainer from "./MapContainer";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { DeleteIcon } from '../bundles/IconsBundle';
import Editor from './Editor';
import { Text } from '../extensions/LangaugeContainer';
import Barcode from 'react-barcode';
//import default from '@material-ui/core/Tabs/TabIndicator';
// import { object } from 'prop-types';
// import { SelectedAppSelector } from '../selectors/SelectedAppointmentSelector';
// // import { SelectAppointmentByID } from '../actions/TaskActions';
// import {
//   SelectAppointmentByID,
//   SetPropertyValue,
//   SavePropertyValue,
//   SaveData,
//   FotoAdd,
//   FotoRemove,
// } from "../actions/TaskActions";

const styles = {
  paper: {
    marginBottom: "10px",
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "left",
    color: "#444",
    width: "100%",
    fontSize: 16,
  },
  div: {
    display: "block",
    float: "left",
    textAlign: "left",
    paddingLeft: "10px",
    zIndex: 999
  },
  cont: {
    //overflowY: "hidden",
    //height: "calc(100vh - 100px)",
    height: "auto",
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    flex: 1
  },
  map: {
    width: "70%",
    height: "50vh",
    margin: "0px 15% 10px 10%",
    overflowY: "visible"
  }
}

class Kunde extends Component {

  checkForLagerAdresse = (val) => {
    return ((val.lieferOrt !== undefined && val.lieferOrt !== null && val.lieferOrt !== "")
      || (val.lieferPlz !== undefined && val.lieferPlz !== null && val.lieferPlz !== "")
      || (val.liferStrasse !== undefined && val.liferStrasse !== null && val.liferStrasse !== ""));
  }

  // saveData = async () => {
  //   const data = {
  //     // EkOrt: this.props.app.EkOrt,
  //     // EkPLZ: this.props.app.EkPLZ,
  //     PlzOrt : this.props.app.PlzOrt,
  //     EkStrasse: this.props.app.EkStrasse
  //   }
  //   console.log("data:", data, "Props: ", this.props.app);
  //   await this.props.SaveData(this.props.app, data);
  // }

  // handleChange = async e => {
  //   await this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value);
  // }

  // handleBlur = async e => {
  //   this.saveData();
  // }

  EditPerson = (app, val) =>  e => {
    this.props.history.push(
      "/addperson/" + app.UniqueID + "/" + val
    );
  }

  handleAdressChange = e => {
    if(e){
      switch(e.target.name){
        case "EkStrasse":
           this.props.SaveData(this.props.app, {EkStrasse: e.target.value})
           this.getNewCoords(this.props.app.EkOrt, e.target.value);
          break;
        case "EkOrt":
           this.props.SaveData(this.props.app, {PlzOrt: e.target.value})
           this.getNewCoords(e.target.value,this.props.app.EkStrasse);
          break;
        default:
          break;
      }
    }


  }

  getNewCoords = (ort,strasse) => {
   fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + strasse + "," + ort + "&key=AIzaSyD2eK5LTngWgTTvyt17ijwNYTzwoGfhk6Q", {
      method:"GET",
    })
      .then(response => {
          if(response.status === 200){
              return response.json();
          }else{
              return false;
          }
      })
      .then(data => {
          //console.log(data.results[0].geometry.location.lat);
          this.props.SetPropertyValue(this.props.app, 'Lat', data.results[0].geometry.location.lat);
          this.props.SetPropertyValue(this.props.app, 'Lng', data.results[0].geometry.location.lng);
          this.props.SaveData(this.props.app, {Lat: data.results[0].geometry.location.lat})
          this.props.SaveData(this.props.app, {Lng: data.results[0].geometry.location.lng})
      })
      .catch(function (err){
          return console.log("Error",err);
  });
  }



  render() {
    const app = this.props.app;
    const monteure = this.props.monteure;
    const fotos = this.props.fotos;
    const readOnly = this.props.settings.PrivilegedUser;
    const kundeNr = app.Kunden_Nr;
    //console.log("Kunde props: ", this.props);
    return (
      <div style={styles.cont}>
        <Paper style={styles.paper} elevation={2}>
          <div>
            <Typography component="p" style={{ backgroundColor: "#00B0DE", fontSize: 18, paddingTop: "5px", paddingBottom: "5px" }}>
              <span style={{ color: "#FFF", marginLeft: "5px" }}><Text tid="cusromerAdress"/></span>
            </Typography>
          </div>
          <div style={{ marginTop: "5px" }}>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="customer"/>: </span><span>{app.Kunde} {app.Kunden_Nr}</span>
            </Typography>
          </div>  
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="EkName"/>: </span><span>{app.FirmaName}</span>
            </Typography>
          </div>        
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="orderNumber"/>: </span><span>{app.AuftragNr}</span>
            </Typography>
          </div>          
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="street"/>: </span><span>{app.FirmaStrasse}</span>
            </Typography>
          </div>
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="zipCodePlace"/>: </span><span>{app.FirmaPLZ} {app.FirmaOrt}</span>
            </Typography>
          </div>
          {(app.Tel_1 !== null && app.Tel_1 !== "") && (
            <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
              <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" style={{ marginLeft: "0px" }}>
                <Grid item xs={9} sm={9} md={9} lg={9}>
                  <Typography component="p" style={{ fontSize: 16, paddingTop: "5px" }}>
                    <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="number"/>: </span><span>{app.Tel_1}</span>
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", paddingRight: "5px" }}>
                  <Button
                    size="small"
                    elevation="1"
                    aria-label="Tel"
                    style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA" }}
                    href={"tel:" + app.Tel_1}
                  >
                    <PhoneIcon style={{ color: "#00B0DE" }} />
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}
          {(app.Tel_2 !== null && app.Tel_2 !== "") && (
            <div style={{ marginTop: "5px" }}>
              <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" style={{ marginLeft: "0px" }}>
                <Grid item xs={9} sm={9} md={9} lg={9}>
                  <Typography component="p" style={{ fontSize: 16, paddingTop: "5px" }}>
                    <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="number"/>: </span><span>{app.Tel_2}</span>
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", paddingRight: "5px" }}>
                  <Button
                    size="small"
                    elevation="1"
                    aria-label="Tel"
                    style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA" }}
                    href={"tel:" + app.Tel_2}
                  >
                    <PhoneIcon style={{ color: "#00B0DE" }} />
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="deliveryDate"/>: </span><span>{moment(app.DestinationDate).format("DD.MM.YYYY")}</span>
            </Typography>
          </div>
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="deliveryTime"/>: </span><span>{moment(app.DestinationDate).format("HH:mm")}</span>
            </Typography>
          </div>
          {(kundeNr !== null && kundeNr !== "" && kundeNr !== undefined) && (
            <div style={{height: "150px", textAlign: "center"}}>
              <Barcode value={kundeNr}/>
            </div>
          )}
        </Paper>

        <Paper style={styles.paper} elevation={2}>
          <div>
            <Typography component="p" style={{ backgroundColor: "#00B0DE", fontSize: 18, paddingTop: "5px", paddingBottom: "5px" }}>
              <span style={{ color: "#FFF", marginLeft: "5px" }}><Text tid="deliveryAdress"/></span>
            </Typography>
          </div>
          <div style={{ marginTop: "5px" }}>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="customer"/>: </span><span>{app.EkName}</span>
            </Typography>
          </div>
          <div>
            <span style={{ verticalAlign: "middle", display: "inline-block" }}>
              <Typography component="p" style={{ fontSize: 16, paddingTop: "4px" }}>
                <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="street"/>: </span>
              </Typography>
            </span>
            <span>
              <TextField
                value={app.EkStrasse || ""}
                name="EkStrasse"
                //onBlur={(e) => this.props.SaveData(this.props.app, {EkStrasse: e.target.value})}
                onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
                // onChange={this.handleChange}
                onBlur={(e) => this.handleAdressChange(e)}
                style={{ width: "70%" }}
                disabled={readOnly}
              />
            </span>
          </div>
          <div>
            <span style={{ verticalAlign: "middle", display: "inline-block" }}>
              <Typography component="p" style={{ fontSize: 16, paddingTop: "4px" }}>
                <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="zipCodePlace"/>: </span>
              </Typography>
            </span>
            <span>
              <TextField
                value={app.EkPLZ || ""} //+ " " + app.EkPLZ
                name="EkPlz"
                onBlur={(e) => this.props.SaveData(this.props.app, {PlzOrt: e.target.value})}
                onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
                //value={app.EkOrt + " " + app.EkPLZ}
                style={{ width: "24%", marginLeft: "6px" }}
                disabled={readOnly}
              />
            </span>
            <span>
              <TextField
                value={app.EkOrt || ""} //+ " " + app.EkPLZ
                name="EkOrt"
                //onBlur={(e) => this.props.SaveData(this.props.app, {PlzOrt: e.target.value})}
                onBlur={this.handleAdressChange}
                onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
                //value={app.EkOrt + " " + app.EkPLZ}
                style={{ width: "45%", marginLeft: "4px" }}
                disabled={readOnly}
              />
            </span>
            
          </div>
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="commission"/>: </span><span>{app.Kommision}</span>
            </Typography>
          </div>
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="driverNotes"/>: </span><span>{app.FahrerNotiz}</span>
            </Typography>
          </div>
        </Paper>
        {(this.checkForLagerAdresse(app)) && (
          <Paper style={styles.paper} elevation={2}>
            <div>
              <Typography component="p" style={{ backgroundColor: "#00B0DE", fontSize: 18, paddingTop: "5px", paddingBottom: "5px" }}>
                <span style={{ color: "#FFF", marginLeft: "5px" }}><Text tid="warehouseAddress"/></span>
              </Typography>
            </div>
            {(app.liferStrasse !== null && app.liferStrasse !== "") && (
              <div style={{ marginTop: "5px" }}>
                <Typography component="p" style={{ fontSize: 16 }}>
                  <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="street"/>: </span><span>{app.liferStrasse || ""}</span>
                </Typography>
              </div>
            )}
            {((app.lieferPlz !== null && app.lieferPlz !== "") || (app.lieferOrt !== null && app.lieferOrt !== "")) && (
              <div>
                <Typography component="p" style={{ fontSize: 16 }}>
                  <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="zipCodePlace"/>: </span><span>{app.lieferPlz} {" "} {app.lieferOrt} </span>
                </Typography>
              </div>
            )}
          </Paper>
        )}
          <Paper style={styles.paper} elevation={2}>
          <div>
            <Typography component="p" style={{ backgroundColor: "#00B0DE", fontSize: 18, paddingTop: "5px", paddingBottom: "5px" }}>
              <span style={{ color: "#FFF", marginLeft: "5px" }}><Text tid="customerSpecifics"/></span>
            </Typography>
          </div>
       <Editor SetPropertyValue = {this.props.SetPropertyValue} SaveData = {this.props.SaveData} App = {this.props.app} disabled={readOnly}/>

        </Paper>
        <Paper style={styles.paper} elevation={2}>
          <div>
            <Typography component="p" style={{ backgroundColor: "#00B0DE", fontSize: 18, paddingTop: "5px", paddingBottom: "5px" }}>
              <span style={{ color: "#FFF", marginLeft: "5px" }}><Text tid="assemblers"/></span>
            </Typography>
          </div>
          {/* mapirati array montera */}
          {monteure.length === 0 && (
            <div>
              <Typography component="p" style={{ margin: "5px", fontSize: 16 }}>
              <Text tid="noAssemblers"/>
              </Typography>
            </div>
          )}
          {monteure.length !== 0 && (
            <Table>
              <TableBody>
                {monteure.map(val => (
                  <TableRow key={val.id}>
                    <TableCell>
                      <span style={{ color: "#00B0DE", padding: "0px", fontSize: 16 }}>
                        {val.Name}{" "}{val.Vorname}:</span> <span>{val.Tel_1}
                      </span>
                    </TableCell>
                    <TableCell style={{ paddingRight: "5px", textAlign: "right" }}>
                      <Button
                        size="small"
                        elevation="1"
                        aria-label="Tel"
                        style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", marginRight: "5px" }}
                        href={"tel:" + val.Tel_1}
                      >
                        <PhoneIcon style={{ color: "#00B0DE" }} />
                      </Button>
                      <Button
                        size="small"
                        elevation="1"
                        aria-label="Edit"
                        value={val.id}
                        style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", marginRight: "5px" }}
                        disabled={readOnly}
                      >
                        <EditIcon onClick={this.EditPerson(app, val.id)}  style={{ color: "#00B0DE" }}  disabled={readOnly}/>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}


        </Paper>
        {/* <Paper style={styles.paper} elevation={2}> */}
        <Table style={{display: "block"}}>
          <TableBody>
            <TableRow >
              <TableCell style={{ border: 0 }}>
                <GridList cellHeight={160} cols={3}>
                  {fotos.map((tile, index) => (
                    <GridListTile cols={1} key={index} style={{ border: '1px solid #DDD' }}>
                      <img src={tile.data} alt="" />
                      <GridListTileBar
                        actionIcon={
                          <Button 
                          disabled={readOnly}
                          onClick={() => { this.removeImage(tile.id) }}>
                            <DeleteIcon color="secondary" />
                          </Button>
                        }
                      />
                    </GridListTile>
                  ))}
                </GridList>
              </TableCell>
            </TableRow>
          </TableBody>
          </Table>
        {/* </Paper> */}
        <div onTouchStart={() => this.props.startMapSwipe()} onTouchEnd={() => this.props.endMapSwipe()} style={{ backgroundColor: '#000' }}>
          <MapContainer lat={app.Lat} lng={app.Lng} map={styles.map} />
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

export default connect(mapStateToProps, {})(Kunde);

//export default withRouter(Kunde);
